import { countryLocaleMapping } from '~/utils/countriesWithLocaleMapping';
import { useGeolocationCookie } from '~/stores/geoinformationStore/useGeolocationCookie';
import { useGeoinformationStore } from '~/stores/geoinformationStore/geoinformationStore';

export const ensureValidCountryMiddleware = () => {
  const { $locale } = useNuxtApp();
  const cookie = useGeolocationCookie();
  const geoInformationStore = useGeoinformationStore();

  const countriesForLocale = countryLocaleMapping.find(
    (locale) => locale?.locale === $locale.value
  );

  const code = countriesForLocale?.identifier.find(
    (countryCode) => countryCode === cookie?.value?.preferredCountry
  );
  if (!code) {
    geoInformationStore.updatePreferredSettings({
      locale: $locale.value,
      country: countriesForLocale?.fallback
    });
  }
};

export default defineNuxtRouteMiddleware(ensureValidCountryMiddleware);
